import React from "react";
import EEIcon from "@Components/Icons/Networks/EE";
import EEPlanIcon from "@Components/Icons/Networks/EEPlan.com";
import O2Icon from "@Components/Icons/Networks/O2";
import O2PlanIcon from "@Components/Icons/Networks/O2Plan.com";
import ThreeIcon from "@Components/Icons/Networks/Three";
import VodafoneWithoutTextIcon from "@Components/Icons/Networks/VodafoneWithoutText";
export const networkNames = {
    vodafone: "Vodafone",
    ee: "EE",
    o2: "O2",
    three: "Three",
    o2Plan: "O2 Plan.com",
    eePlan: "EE Plan.com",
};
export { isNetworkId } from "./types";
export const renderNetworkIcon = (id, className) => {
    const props = { size: "32px", className };
    switch (id) {
        case "ee":
            return React.createElement(EEIcon, { ...props });
        case "eePlan":
            return React.createElement(EEPlanIcon, { ...props });
        case "vodafone":
            return React.createElement(VodafoneWithoutTextIcon, { ...props });
        case "o2":
            return React.createElement(O2Icon, { ...props });
        case "o2Plan":
            return React.createElement(O2PlanIcon, { ...props });
        case "three":
            return React.createElement(ThreeIcon, { ...props });
    }
};
